const initialState = {
    // Initial data,
};

const homePage = (state = initialState, action:any) => {
    switch (action.type) {
      
        case 'SET_SCHEDULE_FILTER':
            return {
                ...state,
                schedule_filter: action.payload
            };

        default:
            return state
    }
}

export default homePage;